import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import SearchInput from 'components/SearchInput';
import { FormContainer, useStyles } from './styles';
import { useRouter } from 'next/router';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import ja from './locales/en';
import zh from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';

const Props = {
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
};

export default function GalleryHero({ searchValue, onSearchChange, onSearchSubmit }) {
  const classes = useStyles();
  const formElement = useRef(undefined);
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  const handleSearchSubmit = async () => {
    if (!formElement.current.checkValidity()) {
      formElement.current.reportValidity();
      return;
    }

    await onSearchSubmit();
  };

  return (
    <section>
      <Container>
        <Box pt={4} pb={2}>
          <Typography
            className={classes.titleScientific}
            align="center"
            component="h2"
            variant="h5"
          >
            <b>{t.title}</b>
          </Typography>
        </Box>

        <Typography align="center" component="p">
          {t.subTitle}
        </Typography>

        <FormContainer ref={formElement}>
          <SearchInput
            value={searchValue}
            onChange={onSearchChange}
            onSubmit={handleSearchSubmit}
            formRef={formElement}
            label={t.label}
          />
        </FormContainer>
      </Container>
    </section>
  );
}

GalleryHero.propTypes = Props;
